import { useChainId } from 'wagmi'
import { Mainnet } from '~/model/chain/ethereum'

export const useIsValidNetwork = () => {
  const chainId = useChainId()
  return chainId === Mainnet.chainId
}
